import { Input, InputGroup, InputRightElement, InputProps } from "@chakra-ui/react";
import { NumericFormat, NumericFormatProps } from "react-number-format";

type PercentFieldV2Props = Omit<NumericFormatProps<InputProps>, "customInput">;

export function PercentFieldV2({ ...props }: PercentFieldV2Props) {
  return (
    <InputGroup>
      <NumericFormat
        decimalScale={2}
        allowNegative={false}
        placeholder="0.00"
        customInput={Input}
        variant="primary"
        {...props}
      />
      <InputRightElement pr="1rem" pointerEvents="none" children="%" w="fit-content" />
    </InputGroup>
  );
}
